import React from 'react';
import { REVIEW_STATUS, REVIEW_STATUS_TITLES } from '../../constants';
import {
  Header,
  TitleRow,
  Name,
  FieldChip,
  Stats,
  Stat,
  Value,
  Label,
  Track,
  Fill,
  Note
} from './ReviewHeader.styles';

export const ReviewHeader = ({ count, status, reviewed, field, onClearField }) => {
  const isPending = status === REVIEW_STATUS.pending;
  const total = count + reviewed;
  const progress = total ? Math.floor((reviewed / total) * 100) : 0;

  return (
    <Header>
      <TitleRow>
        <Name>Stone review</Name>
        {field && (
          <FieldChip type='button' onClick={onClearField}>
            {field.name} ×
          </FieldChip>
        )}
      </TitleRow>
      <Stats>
        <Stat>
          <Value>{count.toLocaleString()}</Value>
          <Label>
            {REVIEW_STATUS_TITLES[status].toLowerCase()}
            {field ? ' in this field' : ''}
          </Label>
        </Stat>
        <Stat>
          <Value>{reviewed.toLocaleString()}</Value>
          <Label>reviewed this session</Label>
        </Stat>
      </Stats>
      {isPending && (
        <Track aria-label={`${progress}% reviewed this session`}>
          <Fill $size={progress} />
        </Track>
      )}
      <Note>Growers see only the stones you confirm. Biggest stones come first.</Note>
    </Header>
  );
};
